/**
 * El color de fila de Lista de Precios (ADR 0079).
 *
 * Va aparte porque no rompe nada: simplemente deja de distinguir un precio
 * programado de uno vencido, que en la tabla se leen igual y significan lo
 * contrario.
 */

/**
 * El fondo de la fila según el estado — `getEstadoRowBackground` de `imprenta`.
 *
 * El vigente no se tiñe a propósito: es el caso normal, y teñir todo es no
 * teñir nada.
 */
export function fondoDeFila(estado: "vigente" | "futuro" | "expirado"): string {
  if (estado === "futuro") return "bg-amber-50/50";
  if (estado === "expirado") return "bg-neutral-50";
  return "";
}

/** Lo mínimo que necesita el armado de opciones del filtro. */
export interface FilaConTipos {
  tipoTamanoId: string;
  tamano: string;
  tipoBaseId: string;
  base: string;
}

/**
 * Las opciones de los filtros de tamaño y base, **agrupadas por el tipo**.
 *
 * Agrupando por `tamanoId` —el id de la fila producto×tamaño, que hay uno por
 * producto— el filtro mostraba **285 opciones que decían todas «Mediano»**.
 * `imprenta` agrupa por el tipo de tamaño, y por eso su lista tiene tres.
 *
 * Ordenadas por nombre con `es`, para que la Ñ no caiga después de la Z.
 */
export function opcionesDeCombinacion(filas: readonly FilaConTipos[]): {
  tamanos: [string, string][];
  bases: [string, string][];
} {
  const porNombre = (a: [string, string], b: [string, string]) => a[1].localeCompare(b[1], "es");
  return {
    tamanos: [...new Map(filas.map((f) => [f.tipoTamanoId, f.tamano])).entries()].sort(porNombre),
    bases: [...new Map(filas.map((f) => [f.tipoBaseId, f.base])).entries()].sort(porNombre),
  };
}
